import LotCell from '../components/DataTable/LotCell';
import MultiLineHeader from '../components/DataTable/MultiLineHeader';
import HorseNameCellConnected from '../components/DataTable/HorseNameCellConnected';
import HorseSireCellConnected from '../components/DataTable/HorseSireCellConnected';
import DamDamSireCell from '../components/DataTable/DamDamSireCell';
import SalePriceCell from '../components/DataTable/SalePriceCell';
import ExpandCell from '../components/DataTable/ExpandCell';
import SelectedCell from '../components/DataTable/SelectedCell';
import ResponsiveHeader from '../components/DataTable/ResponsiveHeader';
import ResponsiveCell from '../components/DataTable/ResponsiveCell';

const DATA_TITLE = 'data-title';
const rootData = document.getElementById('root').dataset || {};

/**
 * Config for entries sales table
 */
export default {
    url: '/bloodstock/sales/my-shortlist/data.json',
    primaryColumn: 'lot_no',
    tableClass: 'table__SalesShortlistTable',
    activeLot: rootData.lot,
    initialPage: rootData.page,
    columns: [
        {
            columnName: '_spacer',
            displayName: '',
            headerDataAttrs: {
                [DATA_TITLE]: 'expand'
            },
            customCell: ExpandCell
        },
        {
            columnName: 'lot_no',
            headerDataAttrs: {
                [DATA_TITLE]: 'lotNo'
            },
            customHeader: {
                component: ResponsiveHeader,
                options: {
                    displayName: [
                        {
                            className: '',
                            displayName: 'Lot'
                        }
                    ]
                }
            },
            customCell: {
                component: LotCell,
                options: {
                    letter: 'lot_letter'
                }
            }
        },
        {
            columnName: 'horse_style_name',
            displayName: 'Horse name',
            customCell: {
                component: HorseNameCellConnected,
                options: {
                    horseUid: 'horse_uid',
                    horseName: 'horse_style_name',
                    entered: 'entered',
                    entryDetails: 'entry_details',
                    courseId: 'course_uid',
                    courseName: 'course_name',
                    raceDate: 'race_date',
                    raceId: 'race_uid',
                    showShortlist: false,
                    showNote: true
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'horse-name'
            }
        },
        {
            columnName: 'horse_style_name / sire_style_name',
            filterBy: 'horse_style_name',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Horse name'
                        },
                        {
                            text: 'Sire'
                        }
                    ]
                }
            },
            customCell: {
                component: HorseSireCellConnected,
                options: {
                    horseUid: 'horse_uid',
                    horseName: 'horse_style_name',
                    sireUid: 'sire_uid',
                    sireName: 'sire_style_name',
                    entered: 'entered',
                    entryDetails: 'entry_details',
                    courseId: 'course_uid',
                    courseName: 'course_name',
                    raceDate: 'race_date',
                    raceId: 'race_uid',
                    showShortlist: false,
                    showNote: true
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'horse_style_name / sire_style_name'
            }
        },
        {
            columnName: 'horse_sex',
            displayName: 'Sex',
            headerDataAttrs: {
                [DATA_TITLE]: 'sex'
            }
        },
        {
            columnName: 'sale_name / price_styled_short',
            filterBy: 'sale_name',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Sale'
                        },
                        {
                            text: 'Price'
                        }
                    ]
                }
            },
            customCell: {
                component: SalePriceCell,
                options: {
                    saleName: 'sale_name',
                    salePrice: 'price_styled_long'
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'sale-date-name'
            }
        },
        {
            columnName: 'horse_age',
            displayName: 'Age',
            headerDataAttrs: {
                [DATA_TITLE]: 'age'
            }
        },
        {
            columnName: 'dam_style_name',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: ['Dam', 'Dam\'s sire']
                }
            },
            customCell: {
                component: DamDamSireCell,
                options: {
                    damUid: 'dam_uid',
                    damName: 'dam_style_name',
                    damSireUid: 'sire_of_dam_uid',
                    damSireName: 'sire_of_dam_style_name'
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'dam-sire'
            }
        },
        {
            columnName: 'seller_name',
            displayName: 'Vendor',
            headerDataAttrs: {
                [DATA_TITLE]: 'seller-name'
            }
        },
        {
            columnName: 'price',
            displayName: 'Price',
            headerDataAttrs: {
                [DATA_TITLE]: 'price'
            },
            customCell: {
                component: ResponsiveCell,
                options: {
                    columns: [
                        {
                            name: 'price_styled_long'
                        }
                    ]
                }
            }
        },
        {
            columnName: 'buyer_detail',
            displayName: 'Buyer',
            headerDataAttrs: {
                [DATA_TITLE]: 'buyer_detail'
            }
        },
        {
            columnName: 'sale_name',
            displayName: 'Sale',
            headerDataAttrs: {
                [DATA_TITLE]: 'sale-name'
            }
        },
        {
            columnName: '_selected',
            customHeader: {
                component: SelectedCell
            },
            customCell: {
                component: SelectedCell,
                options: {}
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'selected'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/shortlistTable.js